import styled from "styled-components/native";
import { Platform } from "react-native";
import { dimenWidth } from "../../utils/helper";

export default styled.View`
  margin-right: ${dimenWidth(4)}px;
  width: 100%;
  ${Platform.OS === "web" ? `flex-shrink: initial !important;` : `flex: 1;`}
`;
